import styled from "styled-components";

export const ReservationInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	h1 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 0px;
	}
	@media screen and (min-width: 300px) and (max-width: 1000px) {
    h1 {
      font-size: 16px;
      line-height: 22px;
      margin-top: 20px;
    }
  }
	@media screen and (min-width: 1000px) and (max-width: 1200px) {
    h1 {
      font-size: 16px;
      line-height: 22px;
    }
  }
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
    h1 {
      font-size: 24px;
      line-height: 28px;
    }
	}
`;

export const NotInfoContent = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 10px;
	margin-top: 25px;
	box-sizing: border-box;
	border: 1px solid rgba(202, 201, 204, 1);
	background-color: rgba(238, 237, 240, 1);
	span {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 20px;
  }
	img {
    width: 67px;
    height: 67px;
  }
  p {
    font-family: 'Suit medium', 'Inter medium';
    color: rgba(151, 151, 153, 1);
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
  }
	@media screen and (min-width: 300px) and (max-width: 1000px) {
		padding: 10px;
		box-sizing: border-box;
		img {
			width: 37px;
			height: 37px;
  	}
		p {
			font-size: 12px;
		}
	}
`

export const InfoContent = styled.div`
	width: 100%;
	height: 51vw;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 10px;
	margin-top: 25px;
	padding: 40px;
	box-sizing: border-box;
	overflow: auto;
	&::-webkit-scrollbar {
		display: block;
		width: 15px;
		border-bottom-right-radius: 10px;
	}
  
	&::-webkit-scrollbar:horizontal {
		height: 5px;
	}
	&::-webkit-scrollbar-thumb{
		background-color: #D9D9D9;
		background-clip: padding-box;
		border: 5px solid transparent;
		border-radius: 10px;
	}
	&::-webkit-scrollbar-track{
		border: solid 1px transparent;
		background-color: #FFFFFF;
		border: 15px;
	}
	
	@media screen and (min-width: 300px) and (max-width: 700px) {
    height: 80vw;
		padding: 10px;
  }
	@media screen and (min-width: 700px) and (max-width: 1200px) {
    height: 60vw;
		padding: 18px;
  }
	@media screen and (min-width: 1200px) and (max-width: 1390px) {
    padding: 20px;
  }
	span {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
	}
	h3 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 18px;
		font-weight: 700;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 0px;
		display: flex;
		justify-content: space-between;
		column-gap: 0.2rem;
		align-items: center;
		@media screen and (min-width: 300px) and (max-width: 700px) {
			font-size: 14px;
		}
		@media screen and (min-width: 700px) and (max-width: 1200px) {
			font-size: 16px;
		}
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			font-size: 22px;
  	}
	}
	p {
		font-family: 'Inter regular';
		font-weight: 400;
		font-size: 10px;
		color: rgba(151, 151, 153, 1);
		line-height: 22px;
		@media screen and (min-width: 700px) and (max-width: 1200px) {
			font-size: 8px;
		}
		@media screen and (min-width: 1025px) and (max-width: 1200px) {
			font-size: 9px;
		}
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			font-size: 18px;
			line-height: 32px;
			font-family: 'Suit medium';
			font-weight: 500;
		}
	}
`

export const RefreshButton = styled.button<{ disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #CAC9CC;
  border: none;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 14px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  gap: 5px;

  &:hover {
    color: ${({ disabled }) => (disabled ? '#CAC9CC' : '#4a4a4a')};
  }
	
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 18px;
	}

  /* svg {
    animation: ${({ disabled }) => (!disabled ? 'spin 1s linear infinite' : 'none')};
  } */

  /* @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  } */
`;

export const StyledTable = styled.div`
	width: 100%;
	margin-top: 5px;
	margin-bottom: 1px;
	box-sizing: border-box;
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
		margin-top: 20px;
	}
	span {
		width: 100%;
		display: grid;
		grid-template-columns: 50% 50%;
		grid-column-gap: 2%;
		background-color: #EEEDF0;
		padding: 8px 25px;
		border-radius: 5px;
		box-sizing: border-box;
		&:nth-child(1) {
			grid-template-columns: 32% 32% 32%;
		}
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
				padding: 10px 27px;
		}
		p {
			font-family: 'Suit regular';
			font-size: 10px;
			line-height: 22px;
			color: rgba(38, 38, 38, 1);
			text-align: center;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			@media screen and (min-width: 1000px) and (max-width: 1200px) {
				font-size: 8px;
				line-height: 18px;
			}
			@media screen and (min-width: 1920px) and (max-width: 5000px) {
				font-size: 20px;
				line-height: 32px;
			}
		}
	}
	div {
		width: 100%;
		display: grid;
		grid-template-columns: 50% 50%;
		grid-column-gap: 2%;
		padding: 8px 25px;
		&:nth-child(2) {
			grid-template-columns: 32% 32% 32%
		}
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
				padding: 10px 27px;
			}
		p {
			font-family: 'Inter regular', 'Suit regular';
			font-size: 14px;
			line-height: 22px;
			color: rgba(38, 38, 38, 1);
			text-align: center;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			@media screen and (min-width: 1920px) and (max-width: 5000px) {
				font-size: 22px;
				line-height: 32px;
			}
		}
	}
	@media screen and (min-width: 700px) and (max-width: 1390px) {
		span {
			p {
				font-size: 8px;
			}
		}
	div {
		p {
			font-size: 10px;
			line-height: 18px;
		}
	}
  }
`;

export const StyledLine = styled.div`
	width: 150%;
	height: 1px;
	background-color: rgba(215, 215, 215, 1);
	margin: 40px 0 40px -40px;
	@media screen and (min-width: 700px) and (max-width: 1390px) {
		margin: 20px 0 20px -20px;
  }
	@media screen and (min-width: 300px) and (max-width: 1390px) {
		margin: 17px 0 17px -17px;
  }
`;

export const StyledReservationList = styled.div`
	width: 100%;
	margin-top: 25px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	row-gap: 25px;
	justify-content: flex-start;
	align-items: center;
`; 

export const NoneReservation = styled.div`
	width: 100%;
	height: 121px;
	border: 1px solid rgba(215, 215, 215, 1);
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Suit regular';
	font-weight: 400;
	line-height: 18px;
	font-size: 12px;
	border-radius: 5px;
	color: rgba(151, 151, 153, 1);
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 20px;
		height: 200px;
  }
` 

export const ReservationItem = styled.div`
	width: 100%;
	padding: 18px;
	box-sizing: border-box;
	border: 1px solid rgba(215, 215, 215, 1);
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	span {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;	
		article {
			width: 100%;
			margin-top: 10px;
			@media screen and (min-width: 1920px) and (max-width: 5000px) {
				margin-top: 20px;
			}
		}
	}
	article {
			@media screen and (min-width: 1920px) and (max-width: 5000px) {
				margin-top: 16px;
			}
		}
	article > span {
		width: 100% !important;
		display: flex !important;
		flex-direction: row !important;
		align-items: center !important;
		justify-content: flex-start !important;
		column-gap: 12px; 
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			column-gap: 20px; 
		}
	}
	h4 {
		font-family: 'Suit bold', 'Inter bold';
		font-weight: 700;
		font-size: 14px;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		@media screen and (min-width: 700px) and (max-width: 1390px) {
			font-size: 12px;
		}
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			font-size: 20px;
			line-height: 28px;
		}
	}
	
	h5 {
		font-family: 'Suit bold', 'Inter bold';
		font-weight: 700;
		font-size: 12px;
		line-height: 18px;
		color: rgba(38, 38, 38, 1);
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			font-size: 18px;
			line-height: 28px;
		}
	}
	
	p {
		font-family: 'Suit regular', 'Inter regular';
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: rgba(38, 38, 38, 1);
		@media screen and (min-width: 1920px) and (max-width: 5000px) {
			font-size: 18px;
			line-height: 28px;
		}
	}
`

export const StyledStreamingHeader = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 20px;
`;

export const StyledReservationBtn = styled.button<{status: boolean}>`
	width: 100%;
	height: 52px;
	border-radius: 5px;
	font-size: 16px;
	font-family: 'Suit bold';
	line-height: 22px;
	font-weight: 700;
	background-color: ${props => props.status ? 'rgba(90, 30, 219, 1)' : 'rgba(215, 215, 215, 1)'};
	color: rgba(255, 255, 255, 1);
	cursor: ${props => props.status ? 'pointer' : 'not-allowed'};
	margin-top: 2vw;
	@media screen and (min-width: 300px) and (max-width: 1000px) {
		margin-top: 1vw;
	}
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
		font-size: 20px;
		line-height: 32px;
		height: 68px;
	}
`;

export const ReservationStatusContent = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;